export default "__VITE_ASSET__DZRgRL6c__"